import { useMemo, useState } from "react";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { apiVariable } from "../../api/apiVariable";
import useAuth from "../../hooks/useAuth";
import { OrientationDto } from "../../interfaces/Recruiting/orientation";
import { formatDate } from "../../helpers/formatingFunctions";
import OrientationExpensePopup from "../../components/Recruiting/OrientationExpenses/OrientationExpensePopup";
import OrientationExpensesTable from "../../components/Recruiting/OrientationExpenses/OrientationExpensesTable";

const fetchOrientations = async (token: string | null | undefined) => {
  const { data } = await axios.get(`${apiVariable}/recruiting/orientations`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

const OrientationExpensesPage = () => {
  const { token } = useAuth();
  const [selectedOrientation, setSelectedOrientation] =
    useState<OrientationDto | null>(null);

  const { data: orientations = [] } = useQuery({
    queryKey: ["orientations"],
    queryFn: () => fetchOrientations(token),
    enabled: !!token,
  });

  const orientationOptions = useMemo(
    () => orientations as OrientationDto[],
    [orientations],
  );

  return (
    <Box className="incidents-page">
      <Box
        sx={{
          display: "flex",
          width: "100%",
          gap: 2,
          alignItems: "center",
          flexWrap: "wrap",
          mb: 2,
        }}
      >
        <OrientationExpensePopup
          orientationId={selectedOrientation?.id}
          orientationDriverFirstName={selectedOrientation?.driverFirstName}
          orientationDriverLastName={selectedOrientation?.driverLastName}
        />
        <Autocomplete
          sx={{ minWidth: 0, width: { xs: "100%", sm: 360 } }}
          options={orientationOptions}
          value={selectedOrientation}
          onChange={(_, newValue) => setSelectedOrientation(newValue)}
          getOptionLabel={(option) =>
            `${option.driverFirstName} ${option.driverLastName} • ${formatDate(
              option.orientationDate,
            )}`
          }
          renderInput={(params) => (
            <TextField {...params} label="Select Orientation" />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
        {!selectedOrientation && (
          <Typography variant="body2" color="textSecondary">
            Choose an orientation to view or add expenses.
          </Typography>
        )}
      </Box>
      <OrientationExpensesTable orientationId={selectedOrientation?.id} />
    </Box>
  );
};

export default OrientationExpensesPage;
